<script>
import CardUI from "@/components/UI/CardUI.vue";
import Empty from "@/components/Common/Empty.vue";
import EditorField from "@/components/Projects/Utils/EditorField.vue";
import DatePickerUIDecorator from "@/components/UI/DatePickerUIDecorator.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/ru';
import InputUI from "@/components/UI/InputUI.vue";
import ButtonUI from "@/components/UI/ButtonUI.vue";
import project_meets from "@/api/project_meets";

export default {
  name: "ProjectCalendarComponent",
  components: {ButtonUI, InputUI, DatePickerUIDecorator, EditorField, Empty, CardUI, DatePicker},
  methods: {
    async save() {
      this.loading = true;
      this.editMeet.duration = 0;
      if (!this.editMeet.id) {
        await project_meets.create({...this.editMeet, project_id: this.$store.state.projects.currentProject.id})
      } else {
        await project_meets.update({...this.editMeet, project_id: this.$store.state.projects.currentProject.id})
      }
      await this.load();
      this.loading = false;
      this.createDialogOpen = false;
      this.clearDialog();

    },
    async remove(meet) {
      if (confirm('Удалить мероприятие?')) {
        await project_meets.delete({id: meet.id, project_id: this.project.id})
        await this.load();
      }
    },
    async load() {
      this.meets = [];
      this.meets = (await project_meets.all({id: this.$store.state.projects.currentProject.id})).data;
    },
    clearDialog() {
      this.editMeet = {
        title: null,
        duration: null,
        start_at: null,
        end_at: null,
        results: null,
        participants: null,
        place: null,
        agenda: null,
        id: null,
      };


        this.$refs.agendaEditor.clear();
        this.$refs.resultsEditor.clear();
    },
  },
  computed: {
    project() {
      return this.$store.state.projects.currentProject;
    },
    approvedParticipants() {
      return this.$store.state.projects.currentProjectParticipants
          .filter(p => p.pivot.approved)
          .map(p => ({
            text: `${p.first_name} ${p.last_name}`,
            value: `${p.first_name} ${p.last_name}`
          }))
    }
  },

  async mounted() {
    await this.load();
  },
  data() {
    return {
      meets: [],
      createDialogOpen: false,
      loading: false,
      text: null,
      editMeet: {
        title: null,
        duration: null,
        start_at: null,
        end_at: null,
        results: null,
        participants: null,
        place: null,
        agenda: null,
        id: null,
      }
    }
  }
}
</script>

<template>
  <div>

    <v-dialog @click:outside="clearDialog" style="top: 100px !important;"
              v-model="createDialogOpen"
              max-width="600"
    >
      <CardUI :loading="false">
        <template slot="body">
          <v-card-title v-if="!editMeet.id" class="headline">
            Создание мероприятия
          </v-card-title>
          <v-card-title v-else class="headline">
            Редактирование мероприятия
          </v-card-title>
          <div class="pa-4">
            <h4 class="my-2">Название мероприятия</h4>
            <InputUI v-model="editMeet.title" counter dense outlined
                     placeholder="Встреча с заказчиком" prepend-icon="mdi-text"></InputUI>

            <h4 class="my-2">Дата начала мероприятия</h4>
            <DatePickerUIDecorator>
              <DatePicker format="DD.MM.YYYY HH:mm"
                          :range=false
                          value-type="YYYY-MM-DD HH:mm"
                          :show-second="false"
                          v-model="editMeet.start_at"
                          placeholder="Дата начала"
                          type="datetime"></DatePicker>
            </DatePickerUIDecorator>

            <h4 class="my-2">Дата окончания мероприятия</h4>
            <DatePickerUIDecorator>
              <DatePicker format="DD.MM.YYYY HH:mm"
                          :range=false
                          value-type="YYYY-MM-DD HH:mm"
                          :show-second="false"
                          v-model="editMeet.end_at"
                          placeholder="Дата окончания"
                          type="datetime"></DatePicker>
            </DatePickerUIDecorator>
            <div
                v-if="editMeet.start_at && editMeet.end_at && $moment(editMeet.end_at).isBefore($moment(editMeet.start_at))"
                style="color:red">
              Дата окончания должна быть позже даты начала
            </div>
            
            <EditorField ref="agendaEditor" class="mt-3" v-model="editMeet.agenda" placeholder="Здесь можно писать"
                         description="Описание мероприятия, конкретные вопросы, которые будут обсуждаться на мероприятии"
                         label="Цель мероприятия"/>
            <EditorField ref="resultsEditor" class="mt-3" v-model="editMeet.results" placeholder="Здесь можно писать"
                         description="Результат мероприятия, заполняется после мероприятия"
                         label="Результат мероприятия"/>

            <h4 class="my-2">Место проведения мероприятия</h4>
            <InputUI v-model="editMeet.place" counter dense outlined
                     placeholder="У505" prepend-icon="mdi-text"></InputUI>

            <h4 class="my-2">Ответственный</h4>
            <v-select
                v-model="editMeet.participants"
                :items="approvedParticipants"
                item-text="text"
                item-value="value"
                placeholder="Выберите участника"
                outlined
                dense
            />

            <ButtonUI v-if="!editMeet.id" @click="save"
                      :disabled="!editMeet.participants || !editMeet.start_at || !editMeet.agenda || !editMeet.place || !editMeet.title || $moment(editMeet.end_at).isBefore($moment(editMeet.start_at))">
              Создать мероприятие
            </ButtonUI>
            <ButtonUI v-else @click="save"
                      :loading="loading"
                      :disabled="!editMeet.participants || !editMeet.start_at || !editMeet.agenda || !editMeet.place || !editMeet.title || $moment(editMeet.end_at).isBefore($moment(editMeet.start_at))">
              Сохранить
            </ButtonUI>
          </div>
        </template>
      </CardUI>
    </v-dialog>
    <v-sheet class="pa-4 mb-2" style="border-radius: 10px;">
      <h4 class="title">План реализации проекта
        <div style="cursor:pointer;" @click="createDialogOpen = true" class="float-right add-task">
          <v-icon>mdi-plus</v-icon>
        </div>

      </h4>
    </v-sheet>
    <Empty class="w-100" title="Пока нет мероприятий," description="но любой участник может создать мероприятие"
           v-if="!meets.length"/>
    <CardUI class="mt-4 pl-2 pt-1 pr-1" v-for="meet in meets" :key="meet.id">
      <template slot="body">
        <h3>{{ meet.title }}
          <v-btn v-if="project.permissions.can_edit_info" @click="editMeet = meet; createDialogOpen = true" right
                 style="float: right" small icon>
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn @click="remove(meet)" right style="float: right" small icon>
            <v-icon color="red">
              mdi-cancel
            </v-icon>
          </v-btn>
        </h3>
        <div color="primary">
          <div style="display: flex; align-items: center; gap: 4px;">
            <v-icon color="primary" small>mdi-calendar-range-outline</v-icon>
            <span>{{ $moment(meet.start_at).format('DD MMMM HH:mm') }} - {{ $moment(meet.end_at).format('DD MMMM HH:mm') }}</span>
          </div>

          <div style="display: flex; align-items: center; gap: 4px;">
            <v-icon color="primary" small>mdi-map-marker-outline</v-icon>
            <span>{{ meet.place }}</span>
          </div>

          <div style="display: flex; align-items: center; gap: 4px;">
            <v-icon color="primary" small>mdi-account-multiple-outline</v-icon>
            <span>  {{ meet.participants }}</span>
          </div>
        </div>

        <EditorField :readonly="true" :id="meet.id" class="mt-4 meet-editorfield" v-model="meet.agenda"
                     placeholder="Здесь можно писать"
                     label="Цель:"/>
        <EditorField v-if="meet.results" :readonly="true" class="mt-5 meet-editorfield" v-model="meet.results"
                     placeholder="Здесь можно писать"
                     :id="meet.id"
                     :label="`Результаты:`"/>

      </template>
    </CardUI>
  </div>
</template>

<style>
@media only screen and (min-width: 800px) {
  .v-dialog {
    margin-top: 100px;
  }
}

.meet-editorfield .editorfield-holder {
  border: none !important;
}

.meet-editorfield .ce-block__content,
.meet-editorfield .ce-toolbar__content {
  margin: 0 !important;
}

.meet-editorfield .ce-paragraph {
  line-height: 1.4;
  font-size: 16px;
  padding: 0 !imoportant;
}

.meet-editorfield .ce-block:last-child {
  margin-bottom: 10px;
}

.meet-editorfield .codex-editor__redactor {
  min-height: unset !important;
}

</style>
